import useSWR from 'swr'
import PrefixService from '../services/prefix'

export const useFetchSetting = () => {
    const prefix = PrefixService.getPrefix()
    const { data, mutate, error } = useSWR([`/setting/website`, prefix], () => PrefixService.getSetting());

    return {
        data,
        isLoading: !error && !data,
        isError: error,

        mutate,
    }
}

export default useFetchSetting
